/**
 * Normalizes GET /api/addresses `data` payload to an array of address objects.
 */
export function addressListFromApi(dataRoot) {
  if (!dataRoot) return [];
  if (Array.isArray(dataRoot)) return dataRoot;
  if (Array.isArray(dataRoot.addresses)) return dataRoot.addresses;
  if (Array.isArray(dataRoot.data)) return dataRoot.data;
  return [];
}
